import PropTypes from "prop-types";
import { useEffect, useMemo } from "react";
import NavigationBar from "../Common/NavigationBar";

import { authorized } from "../../utils/authorizationUtils";

import {
    bypatruljenAll,
    ileggelseadmin,
    innsyn,
    juridiskAll,
    stedfortrederDriftsleder,
} from "../../constants/roles";
import sitePaths from "../../constants/sitePaths";
import * as title from "../../constants/titles";

function NavigationBarContainer({ page }) {
  useEffect(() => {
    document.title = title.innsyn(page);
  }, [page]);

  const authorizedIleggelser = useMemo(
    () =>
      authorized([
        innsyn.vaktsentralen,
        innsyn.serviceavdeling,
        innsyn.kemnerkontoret,
        innsyn.seksjonssjefVaktsentralen,
      ]),
    [],
  );
  const authorizedMiljogebyr = useMemo(
    () =>
      authorized([
        innsyn.vaktsentralen,
        innsyn.serviceavdeling,
        innsyn.kemnerkontoret,
        innsyn.seksjonssjefVaktsentralen,
      ]),
    [],
  );
  const authorizedMotorvogn = useMemo(
    () =>
      authorized([
        ...bypatruljenAll,
        ...juridiskAll,
        innsyn.vaktsentralen,
        innsyn.serviceavdeling,
        innsyn.seksjonssjefVaktsentralen,
        stedfortrederDriftsleder,
      ]),
    [],
  );
  const authorizedPersonopplysninger = useMemo(
    () => authorized([ileggelseadmin]),
    [],
  );

  const navigationItems = useMemo(() => {
    const items = [];
    if (authorizedIleggelser) {
      items.push({
        navn: "Ileggelsesøk",
        path: sitePaths.innsyn.ileggelser.oversikt,
      });
    }
    if (authorizedMiljogebyr) {
      items.push({
        navn: "Miljøgebyrsøk",
        path: sitePaths.innsyn.miljogebyrer.oversikt,
      });
    }
    if (authorizedMotorvogn) {
      items.push({
        navn: "Motorvognsøk",
        path: sitePaths.innsyn.motorvogn.shortUrl,
      });
    }
    if (authorizedPersonopplysninger) {
      items.push({
        navn: "Personopplysninger",
        path: sitePaths.innsyn.personopplysninger,
      });
    }
    return items;
  }, [
    authorizedIleggelser,
    authorizedMiljogebyr,
    authorizedMotorvogn,
    authorizedPersonopplysninger,
  ]);

  return <NavigationBar navigationItems={navigationItems} />;
}

NavigationBarContainer.propTypes = {
  page: PropTypes.string.isRequired,
};

export default NavigationBarContainer;
